(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arena-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-arena-bundle-root]');
  if (!root) return;
  var inputs = root.querySelectorAll('input[name="arena-bundle"]');
  var priceEl = document.querySelector('[data-arena-cta-price]');
  function sync() {
    var checked = root.querySelector('input:checked');
    if (!checked) return;
    document.documentElement.setAttribute('data-arena-bundle', checked.value);
    document.dispatchEvent(new CustomEvent('arena:bundle-change', { detail: { bundle: checked.value } }));
    if (priceEl) priceEl.textContent = checked.value === 'pack' ? '69,90 €' : '39,90 €';
  }
  inputs.forEach(function (i) { i.addEventListener('change', sync); });
  sync();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nua-before-after"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-nua-ba-pair]').forEach(function (pair) {
    var range = pair.querySelector('.nua-ba__range');
    var after = pair.querySelector('.nua-ba__img--after');
    if (!range || !after) return;
    range.addEventListener('input', function () {
      var v = range.value;
      after.style.clipPath = 'inset(0 0 0 ' + v + '%)';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nua-colors"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-nua-colors-root]');
  if (!root) return;
  var btns = root.querySelectorAll('[data-nua-color-idx]');
  var panel = root.querySelector('[data-nua-color-panel]');
  if (!panel) return;
  var nmEl = panel.querySelector('[data-nm]');
  var nameEl = panel.querySelector('[data-name]');
  var benefitEl = panel.querySelector('[data-benefit]');
  var glow = panel.querySelector('.nua-colors__panel-glow');

  function setActive(btn) {
    btns.forEach(function (b) {
      b.classList.remove('is-active');
      b.setAttribute('aria-selected', 'false');
    });
    btn.classList.add('is-active');
    btn.setAttribute('aria-selected', 'true');
    var color = getComputedStyle(btn).getPropertyValue('--c').trim();
    nmEl.textContent = btn.dataset.colorNm || '';
    nameEl.textContent = btn.dataset.colorName || '';
    benefitEl.textContent = btn.dataset.colorBenefit || '';
    panel.style.setProperty('--nua-color-active', color);
  }

  btns.forEach(function (b) {
    b.addEventListener('click', function () { setActive(b); });
    b.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        var arr = Array.from(btns);
        var idx = arr.indexOf(b);
        var next = e.key === 'ArrowRight' ? (idx + 1) % arr.length : (idx - 1 + arr.length) % arr.length;
        arr[next].focus();
        setActive(arr[next]);
      }
    });
  });

  // Init glow color from first active
  var first = root.querySelector('.nua-colors__dot-btn.is-active');
  if (first) setActive(first);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nua-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var slider = document.querySelector("[data-nua-slider]");
  var dotsEl = document.querySelector("[data-nua-dots]");
  if (slider && dotsEl) {
    var slides = slider.querySelectorAll(".nua-hero__media");
    if (slides.length > 1) {
      slides.forEach(function (_, i) {
        var b = document.createElement("button");
        b.type = "button";
        b.setAttribute("aria-label", "Imagen " + (i + 1));
        if (i === 0) b.setAttribute("aria-current", "true");
        b.addEventListener("click", function () {
          slides[i].scrollIntoView({ behavior: "smooth", inline: "start", block: "nearest" });
        });
        dotsEl.appendChild(b);
      });
      var dots = dotsEl.querySelectorAll("button");
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio > 0.6) {
            var idx = Array.prototype.indexOf.call(slides, e.target);
            dots.forEach(function (d, i) {
              if (i === idx) d.setAttribute("aria-current", "true");
              else d.removeAttribute("aria-current");
            });
          }
        });
      }, { root: slider, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });
    } else {
      dotsEl.style.display = "none";
    }
  }
  var viewers = document.querySelector("[data-nua-viewers]");
  if (viewers) {
    setInterval(function () {
      var cur = parseInt(viewers.textContent, 10) || 23;
      var delta = Math.floor(Math.random() * 5) - 2;
      viewers.textContent = Math.max(14, Math.min(42, cur + delta));
    }, 6000);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nua-home-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  var form = document.querySelector('[data-nua-bundle-form-home]');
  if (!form) return;
  var label = form.querySelector('[data-cta-label-home]');
  var radios = form.querySelectorAll('input[name="id"]');
  function sync() {
    var checked = form.querySelector('input[name="id"]:checked');
    if (!checked || !label) return;
    var card = checked.closest('.nua-bundle__opt');
    var priceEl = card ? card.querySelector('.nua-bundle__price') : null;
    var txt = priceEl ? priceEl.textContent.trim() : '';
    label.textContent = txt ? 'Comprar ahora · ' + txt : 'Comprar ahora';
  }
  radios.forEach(function (r) { r.addEventListener('change', sync); });
  sync();

  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function tickShipping() {
    var countdownEls = form.querySelectorAll('[data-nua-shipping-countdown]');
    var dayEls = form.querySelectorAll('[data-nua-shipping-day]');
    if (!countdownEls.length) return;
    var now = new Date();
    var deadline = new Date();
    deadline.setHours(14, 0, 0, 0);
    var today = now < deadline;
    if (!today) deadline.setDate(deadline.getDate() + 1);
    var diff = deadline - now;
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    var txt = (h > 0 ? h + 'h ' : '') + pad(m) + 'm ' + pad(s) + 's';
    countdownEls.forEach(function (el) { el.textContent = txt; });
    dayEls.forEach(function (el) { el.textContent = today ? 'HOY' : 'MAÑANA'; });
  }
  tickShipping();
  setInterval(tickShipping, 1000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nua-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.querySelector('[data-nua-sticky-atc]');
  if (!bar) return;
  bar.hidden = false;
  var threshold = 400;
  var ticking = false;
  function updateCookieOffset() {
    var cookie = document.querySelector('.cookie-consent:not([hidden]), [data-cookie-consent]:not([hidden])');
    var visible = cookie && !cookie.hidden && getComputedStyle(cookie).display !== 'none' && cookie.offsetHeight > 0;
    if (visible) {
      var h = cookie.offsetHeight;
      var style = getComputedStyle(cookie);
      var b = parseFloat(style.bottom) || 0;
      bar.style.setProperty('--nua-sticky-offset', (h + b + 8) + 'px');
    } else {
      bar.style.setProperty('--nua-sticky-offset', '0px');
    }
  }
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        if (window.scrollY > threshold) bar.setAttribute('data-visible', '');
        else bar.removeAttribute('data-visible');
        updateCookieOffset();
        ticking = false;
      });
      ticking = true;
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', updateCookieOffset);
  setInterval(updateCookieOffset, 1200);
  onScroll();
  updateCookieOffset();

  // Sync con bundle selector
  var idInput = bar.querySelector('[data-sticky-id]');
  var priceEl = bar.querySelector('[data-sticky-price]');
  document.addEventListener('nua:bundle-change', function (e) {
    var vid = e.detail && e.detail.variant_id;
    if (!vid || !idInput) return;
    idInput.value = vid;
    var selected = document.querySelector('.nua-bundle__opt input[value="' + vid + '"]');
    if (selected && priceEl) {
      var card = selected.closest('.nua-bundle__opt');
      var p = card ? card.querySelector('.nua-bundle__price') : null;
      if (p) priceEl.textContent = p.textContent.trim();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
